export const FORMULA_REGEXP = /F\d+/;

export const HAVING_FILTER_REGEXP = /^[-\d.,\s]+$/;

export const TYPE_ADDON_REGEXP = /_(.+)/;

export const SPLIT_FIRST_UNDERSCORE = /(?<!^)_/;
